import { render, staticRenderFns } from "./DetailCreateTable.vue?vue&type=template&id=081a1280&scoped=true"
import script from "./DetailCreateTable.vue?vue&type=script&lang=js"
export * from "./DetailCreateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a1280",
  null
  
)

export default component.exports